/* Public openHASP control semantics shared by Bar and Slider. */
export const OPENHASP_CONTROL_TYPE = Object.freeze({
    NORMAL: 0,
    REVERSE: 1,
    SYMMETRICAL: 2,
    RANGE: 3,
})

export const OPENHASP_CONTROL_TYPE_VALUES = Object.freeze([0, 1, 2, 3])

export const OPENHASP_CONTROL_TYPE_OPTIONS = Object.freeze([
    { value: 0, description: 'Normal' },
    { value: 1, description: 'Reverse' },
    { value: 2, description: 'Symmetrical' },
    { value: 3, description: 'Range' },
])

// `definition` is the resolved event definition (see getEventDefinition). It is
// passed in rather than resolved here because the schema registry imports
// this module.
export function openhaspEventPayload(node, event, payload = [], definition = node?.schemaV2?.events?.[event]) {
    const base = [...payload]
    const rangePayload = definition?.rangePayload
    if (Number(node?.type) !== OPENHASP_CONTROL_TYPE.RANGE || !Array.isArray(rangePayload)) {
        return base
    }
    // Firmware serializes a Range event as the fields declared by the event's
    // Range metadata. Preserve ordinary event fields while keeping the stable
    // metadata order and avoiding duplicate fields.
    return [...new Set([
        ...base.filter(id => !rangePayload.includes(id)),
        ...rangePayload,
    ])]
}
